import cookie from 'js-cookie';

const IS_CRAWLER_COOKIE_KEY = 'is_crawler';

/**
 * UAがBotの場合にLambdaEdge側で付与するCookie
 */
export const isCrawler: boolean =
  cookie.get(IS_CRAWLER_COOKIE_KEY) !== undefined;
